<template>
  <div class="approval">
    <div v-if="approve_photo">
      <van-image
        :src="envs + approve_photo"
        width="92%"
        height="200px"
        fit="scale-down"
      />
    </div>
    <div class="PersonnelInformation">
      <div class="header">{{ approve_status }}</div>
      <div class="item">来访人：{{ visitor_name }}</div>
      <div class="item">手机号:{{ visitor_tel }}</div>
      <div class="item">来访人数：{{ user_count }}人</div>
      <div class="item">来访事由：{{ visitor_reason }}</div>
      <div class="item">来访时间：{{ visitor_in_time }}</div>
    </div>
    <div class="gap">
      <a class="approvalImage_a" :class="{'approvalImage': approve_photo}" :href="'tel:' + visitor_tel" v-if="visitor_tel">
        <van-image
          src="https://client.12kcool.com/qingjia.png"
          width="30px"
          height="30px"
          fit="scale-down"
        />
      </a>
    </div>
    <van-steps
      direction="vertical"
      active-color="#1cab7d"
      :active="status === 0 ? 0 : 1"
    >
      <van-step>
        <h3>提交时间</h3>
        <p>{{ create_date }}</p>
      </van-step>
      <van-step>
        <h3>{{ approve_status }}</h3>
        <p>{{ touser_name }}</p>
      </van-step>
    </van-steps>
    <div class="button" v-if="status === 0">
      <!-- <van-button
        color="linear-gradient(to right, #ff6034, #ee0a24)"
        size="normal"
        round
        style="display: none;"
        @click="setApprove()"
        >待定</van-button
      > -->
      <van-button
        color="linear-gradient(to right, #ff6034, #ee0a24)"
        size="normal"
        round
        @click="setApprove(1)"
        >拒绝</van-button
      >
      <van-button size="normal" color="#1cab7d" @click="setApprove(2)" round
        >同意</van-button
      >
    </div>
  </div>
</template>
<script lang="ts">
import {
  defineComponent,
  onMounted,
  ref,
  watch,
  reactive
} from "vue";
import { Image, Steps, Step, Button, Popup, Dialog } from "vant";
import Account from "@/api/account";
import dayjs from "dayjs";

export default defineComponent({
  name: "DetailOld",
  props: {
    approveInfo:{
      type: Object,
      default: () => {}
    }
  },
  data() {
    return { show: false };
  },
  components: {
    "van-image": Image,
    "van-step": Step,
    "van-steps": Steps,
    "van-button": Button,
    "van-popups": Popup
  },
  setup(props, ctx) {
    const visitor_name = ref("");
    const user_count = ref("");
    const visitor_tel = ref("");
    const approve_photo = ref("");
    const visitor_reason = ref("");
    const touser_name = ref("");
    const visitor_in_time = ref("");
    const create_date = ref("");
    const approve_status = ref("");
    const status = ref(0);
    const id = ref("");
    const approve_user_id = ref("");
    //const envs = ref('https://res-mal.12kcool.com/')
    const envs = ref("https://res-k12.12kcool.com/");
    
    const getstatus = (statu: number) => {
      let val = "";
      if (statu === 0) {
        val = "待审批";
      } else if (statu === 1) {
        val = "审批拒绝";
      } else {
        val = "审批通过";
      }
      return val;
    };
    watch(()=>props.approveInfo, (val)=>{
      console.log('approveInfo', val)
      const data = val || {}
      visitor_name.value = data.visitor_name;
      user_count.value = data.user_count;
      visitor_tel.value = data.visitor_tel;
      approve_photo.value = data.approve_photo;
      visitor_reason.value = data.visitor_info.visitor_reason;
      touser_name.value = data.visitor_info.touser_name;
      visitor_in_time.value = dayjs(data.visitor_in_time).format(
        "YYYY-MM-DD HH:mm"
      );
      create_date.value = dayjs(data.create_date).format(
        "YYYY-MM-DD HH:mm"
      );
      approve_status.value = getstatus(data.visitor_info.approve_status);
      status.value = data.visitor_info.approve_status;
    },{
      deep: true,
      immediate: true
    })
    const setApprove = (status?: number) => {
      let approvalId = ''
      const params = {
        approve_user_id: approve_user_id.value,
      }
      if (!status) {
        approvalId = '-1'
      }
      Dialog.confirm({
        title: '提示',
        message: `确定要${status === 2 ? "同意" : "拒绝"}吗？`,
      })
        .then(async () => {
          // on confirm
          const [err, data] = await Account.setApprove(approvalId || id.value, status, params);
          
          ctx.emit('refresh');
          console.log(data);
        })
        .catch(() => {
          // on cancel
        });
    };
    const setid = async (ids: any) => {
      id.value = ids;
    };
    const setVisitorId = async (ids: any) => {
      approve_user_id.value = ids;
    };

    onMounted(async () => {
      // Notify('onMounteSSSd')
    });

    return {
      envs,
      visitor_name,
      user_count,
      visitor_tel,
      approve_photo,
      visitor_reason,
      touser_name,
      visitor_in_time,
      create_date,
      approve_status,
      status,
      setApprove,
      setid,
      setVisitorId,
      getstatus,
      id,
      approve_user_id
    };
  },
  created() {
    console.log('query', this.$route.query);
    this.setid(this.$route.query.touser_id);
    this.setVisitorId(this.$route.query.approve_user_id);
  }
});
</script>
<style scoped lang="scss">
.approval {
  margin-left: 3%;
  .van-step--finish {
    color: #969799;
  }
  .PersonnelInformation {
    padding: 5px 0;
    .header {
      font-size: 18px;
      color: #efa707;
    }
    .item {
      font-size: 14px;
      color: #666;
    }
  }
  .van-step--vertical {
    padding: 8px 10px 5px 0;
    line-height: 4px;
  }
  .button {
    display: flex;
    justify-content: space-around;
    margin-top: 30px;
    button {
      width: 30%;
    }
  }
  .gap {
    position: relative;
    width: 103%;
    height: 15px;
    background-color: #e8e7e7cc;
    left: -3%;
  }
  .approvalImage_a {
    position: relative;
    left: 150px;
    top: -66px;
  }

  .approvalImage {
    top: -266px;
  }
  .van-steps--vertical {
    padding: 0 0 0 20px;
  }
}
</style>
